(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PartIbqDeleteController',PartIbqDeleteController);

    PartIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Part'];

    function PartIbqDeleteController($uibModalInstance, entity, Part) {
        var vm = this;

        vm.part = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Part.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
